import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { SupplierGroup } from '../models/suppliergroup.model';

@Injectable()
export class SupplierGroupService {
  private supplierGroupUrl: string = 'api/suppliergroups';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStoreManager) { }

  getSupplierGroups(): Observable<SupplierGroup[]> {
    let sitename = this.localStorage.getDataObject("sitename");
    let endpointUrl = `${this.supplierGroupUrl}/${sitename}`;
    return this.http.get<SupplierGroup[]>(endpointUrl);
  }

}

